import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics';
export var SetApprovalForAll = createPlugin({
    protocol: 'ERC1155',
    type: 'ACTION',
    method: 'setApprovalForAll',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155', isPreview: true, }),
                methodParams: {
                    operator: new FctAddress({}),
                    approved: new FctBoolean({}),
                },
            },
            output: {},
        });
    },
});
